import './wakefieldmillenglish/style';
import FormStructure from './wakefieldmillenglish/form_structure';

export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js